const DEFAULT_NAMESPACE = "https://privana.app/claims";

export const AUTH0_NAMESPACE =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    (import.meta.env.VITE_AUTH0_NAMESPACE || import.meta.env.VITE_AUTH0_NAMESPACE === ""))
    ? import.meta.env.VITE_AUTH0_NAMESPACE || DEFAULT_NAMESPACE
    : (typeof process !== "undefined" && process.env?.VITE_AUTH0_NAMESPACE)
    ? process.env.VITE_AUTH0_NAMESPACE
    : DEFAULT_NAMESPACE;

function isPlainObject(value) {
  return value && typeof value === "object" && !Array.isArray(value);
}

export function getScopedClaims(claims) {
  if (!claims) return {};
  if (claims[AUTH0_NAMESPACE]) return claims[AUTH0_NAMESPACE] || {};
  if (claims[DEFAULT_NAMESPACE]) return claims[DEFAULT_NAMESPACE] || {};
  const maybe = Object.entries(claims).find(([key]) => key.includes("privana") && key.endsWith("/claims"));
  if (maybe) return maybe[1] || {};
  return {};
}

export function extractRoleEntries(source) {
  if (!source) return [];
  if (Array.isArray(source)) return source.flatMap((entry) => extractRoleEntries(entry));
  if (typeof source === "string") {
    return source
      .split(/[\s,|]+/)
      .map((segment) => segment.trim())
      .filter(Boolean);
  }
  if (typeof source === "object") {
    return Object.values(source).flatMap((value) => extractRoleEntries(value));
  }
  return [];
}

const ROLE_SOURCE_KEYS = [
  "roles",
  "role",
  "platform_role",
  "platformRole",
  "platform_roles",
  "platformRoles",
  "user_role",
  "userRole",
  "user_roles",
  "userRoles",
  "app_roles",
  "appRoles",
];

export function gatherRolesFromScoped(scoped) {
  if (!isPlainObject(scoped)) return [];
  const raw = ROLE_SOURCE_KEYS.flatMap((key) => extractRoleEntries(scoped[key]));
  const unique = new Set();
  raw.forEach((role) => {
    const trimmed = String(role || "").trim();
    if (trimmed) unique.add(trimmed);
  });
  return Array.from(unique);
}

const ORG_KEYS = [
  "org_slug",
  "orgId",
  "org_id",
  "org",
  "organization",
  "organization_id",
  "club_code",
  "club_code",
  "club_code",
  "club_code",
  "tenant",
  "tenant_id",
  "tenantId",
];

export function getOrgIdentifier(scoped, fallbackClaims = {}) {
  const sources = [scoped, fallbackClaims];
  for (const source of sources) {
    if (!isPlainObject(source)) continue;
    for (const key of ORG_KEYS) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        const value = source[key];
        if (value == null) continue;
        const str = String(value).trim();
        if (str) return str;
      }
    }
  }
  return null;
}

export function getAllowedClubNumbers(scoped) {
  if (!isPlainObject(scoped)) return [];
  const buckets = [
    scoped.allowed_clubs,
    scoped.allowedClubs,
    scoped.clubs,
    scoped.club_access,
    scoped.clubAccess,
  ];
  const values = buckets.flatMap((entry) => extractRoleEntries(entry));
  const seen = new Set();
  values.forEach((value) => {
    const trimmed = String(value || "").trim();
    if (trimmed) seen.add(trimmed);
  });
  return Array.from(seen);
}
